import script from "./story.vue?vue&type=script&setup=true&lang=js"
export * from "./story.vue?vue&type=script&setup=true&lang=js"

import "./story.vue?vue&type=style&index=0&id=73e1e0cc&lang=less&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73e1e0cc"]])

export default __exports__